import { cardItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="mx-auto max-w-[1280px]">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              精选推荐
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
              编辑精选的高质量韩国漫画，每一部都值得细细品味
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
            {cardItems.slice(0, 7).map((item, i) => (
              <article
                key={i}
                className={`group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all duration-300 ${
                  i === 0 ? 'sm:col-span-2 lg:col-span-2 xl:col-span-2' : ''
                }`}
              >
                <div className={`relative w-full ${i === 0 ? 'aspect-[2/1]' : 'aspect-[4/3]'} overflow-hidden`}>
                  <img
                    src={item.cover}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => {
                      (e.currentTarget as HTMLElement).style.display = 'none';
                    }}
                  />
                  <div className="absolute top-3 right-3">
                    <span className={`inline-block px-2 py-0.5 rounded text-[10px] font-bold ${
                      item.status === '连载中'
                        ? 'bg-accent-500 text-background-50'
                        : 'bg-secondary-500 text-background-50'
                    }`}>
                      {item.status}
                    </span>
                  </div>
                  <div className="absolute top-3 left-3">
                    <span className="inline-block px-2 py-0.5 rounded bg-background-50/90 text-primary-600 text-[10px] font-bold">
                      ★ {item.rating}
                    </span>
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-4">
                    <h3 className="text-base md:text-lg font-heading font-bold text-white mb-2">{item.title}</h3>
                    <div className="flex flex-wrap gap-1.5">
                      {item.tags.map((tag) => (
                        <span
                          key={tag}
                          className="inline-block px-2 py-0.5 rounded bg-white/20 text-white text-[10px] font-medium"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="p-4">
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3">{item.desc}</p>
                </div>
              </article>
            ))}
          </div>

          <div className="text-center mt-8">
            <a
              href="#index"
              className="whitespace-nowrap inline-flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors"
            >
              发现更多作品
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}